import { baseURL } from '@/plugins/axios'

export const serviceConfig = {
  baseURL
}
